import { FC, useMemo } from 'react'
import TableWrapper from '../../../../../components/table-wrapper/table-wrapper'
import { Table } from 'antd'
import PrintJob from '../../../../../types/api/print-job'
import { getColumns } from './columns'
import './created-print-jobs.css'
import { useHasRole } from '../../../../../hooks/use-has-role'
import { PRINT_PLAN_EDIT_ROLES } from '../../constants/print-plan-edit-roles'
import { CreatedPrintJobsTab } from './types'

export type { CreatedPrintJobsTab } from './types'

interface CreatedPrintJobsProps {
    tab: CreatedPrintJobsTab
    jobs: PrintJob[]
}

const CreatedPrintJobs: FC<CreatedPrintJobsProps> = ({ tab, jobs }) => {
    const canManagePrintPlan = useHasRole(PRINT_PLAN_EDIT_ROLES)

    const tableColumns = useMemo(() => getColumns(tab, canManagePrintPlan), [tab, canManagePrintPlan])
    const filteredColumns = tableColumns.filter(col => {
        if (col && 'dataIndex' in col && col.dataIndex === 'actions' && !canManagePrintPlan) {
            return false
        }
        return true
    })

    return (
        <TableWrapper style={{ flex: 'auto' }} tableHasNotPagination>
            <Table
                dataSource={jobs}
                columns={filteredColumns}
                pagination={false}
                rowKey={'id'}
                size={'small'}
            />
        </TableWrapper>
    )
}

export default CreatedPrintJobs
